// extracted by mini-css-extract-plugin
export default {"title":"Phonebook_title__ssTUL","form":"Phonebook_form__eZR+N"};